/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Main App component
Author: Deimos Space UK

Version: 1.0
*/
import React from "react";
import "./assets/scss/Saas.scss";
import Roots from "./routes/routes";
import '../src/utils/i18n/i18n';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {CookiesProvider} from 'react-cookie';

function App({ t }) {

	return (
		<>
			<ToastContainer />
			<CookiesProvider>
				<Roots />
			</CookiesProvider>
		</>
	)
}

export default App;
